module.exports = __webpack_public_path__ + "static/media/checked-toggle.08794f12.svg";